window.CTModelBackgrounds = (function () {
  const yellowModelFiles = new Set([
    'sweater-cuello-alto-bariloche-negro-modelo-06.webp', 'sweater-cuello-alto-bariloche-negro-modelo-05.webp', 'sweater-cuello-alto-bariloche-negro-modelo-04.webp', 'sweater-cuello-alto-bariloche-negro-modelo-03.webp',
    'sweater-cuello-alto-bariloche-negro-modelo-02.webp', 'polo-cuello-cuadrado-ombu-blanco-modelo-01.webp', 'polo-cuello-cuadrado-ombu-blanco-modelo-02.webp', 'polo-cuello-cuadrado-ombu-blanco-modelo-03.webp',
    'polo-cuello-cuadrado-ombu-blanco-modelo-04.webp', 'polo-cuello-cuadrado-ombu-azul-modelo-01.webp', 'polo-cuello-cuadrado-ombu-azul-modelo-02.webp', 'polo-cuello-cuadrado-ombu-azul-modelo-03.webp',
    'polo-cuello-cuadrado-ombu-azul-modelo-04.webp', 'polo-cuello-cuadrado-ombu-guinda-modelo-04.webp', 'polo-cuello-cuadrado-ombu-guinda-modelo-01.webp', 'polo-cuello-alto-ushuaia-azul-modelo-03.webp',
    'polo-basico-trenque-lauquen-negro-modelo-04.webp', 'polo-basico-trenque-lauquen-negro-modelo-02.webp', 'polera-cuello-alto-calafate-verde-modelo-06.webp', 'polera-cuello-alto-calafate-verde-modelo-02.webp',
    'polera-cuello-alto-calafate-verde-modelo-01.webp', 'polera-cuello-alto-calafate-negro-modelo-04.webp', 'polera-cuello-alto-calafate-negro-modelo-03.webp', 'polera-cuello-alto-calafate-negro-modelo-02.webp',
    'polera-cuello-alto-calafate-negro-modelo-01.webp', 'pantalon-sastrero-jacaranda-negro-modelo-04.webp', 'pantalon-sastrero-jacaranda-negro-modelo-03.webp', 'pantalon-sastrero-jacaranda-negro-modelo-02.webp',
    'pantalon-sastrero-jacaranda-negro-modelo-01.webp', 'pantalon-sastrero-jacaranda-azul-modelo-04.webp', 'pantalon-sastrero-jacaranda-azul-modelo-03.webp', 'pantalon-sastrero-jacaranda-azul-modelo-02.webp',
    'pantalon-sastrero-jacaranda-azul-modelo-01.webp', 'pantalon-ancho-barolo-gris-modelo-01.webp', 'pantalon-ancho-barolo-azul-modelo-05.webp', 'pantalon-ancho-barolo-azul-modelo-02.webp',
    'abrigo-suede-pampa-verde-modelo-03.webp', 'abrigo-suede-pampa-verde-modelo-05.webp', 'blazer-palermo-azul-modelo-01.webp', 'blazer-palermo-azul-modelo-04.webp',
    'blazer-palermo-beige-modelo-01.webp', 'blazer-palermo-beige-modelo-03.webp', 'blazer-palermo-negro-modelo-01.webp', 'blazer-palermo-negro-modelo-05.webp',
    'blazer-palermo-negro-modelo-06.webp', 'camisa-basica-malabia-blanca-modelo-01.webp', 'camisa-basica-malabia-blanca-modelo-02.webp', 'camisa-basica-malabia-blanca-modelo-03.webp',
    'camisa-basica-malabia-blanca-modelo-04.webp', 'camisa-denim-soho-denim-oscuro-modelo-01.webp', 'camisa-denim-soho-denim-oscuro-modelo-03.webp', 'camisa-denim-soho-denim-oscuro-modelo-04.webp',
    'camisa-denim-soho-denim-oscuro-modelo-05.webp', 'camisa-denim-soho-denim-oscuro-modelo-06.webp', 'camisa-oversize-belgrano-blanco-modelo-01.webp', 'camisa-oversize-belgrano-blanco-modelo-02.webp',
    'camisa-oversize-belgrano-blanco-modelo-03.webp', 'camisa-oversize-belgrano-blanco-modelo-04.webp', 'camisa-oversize-belgrano-blanco-modelo-05.webp', 'camisa-oversize-belgrano-blanco-modelo-06.webp',
    'camisa-oversize-belgrano-negro-modelo-01.webp', 'camisa-oversize-belgrano-negro-modelo-02.webp', 'camisa-oversize-belgrano-negro-modelo-06.webp', 'capa-patagonica-camel-modelo-01.webp',
    'capa-patagonica-camel-modelo-03.webp', 'capa-patagonica-camel-modelo-04.webp', 'capa-patagonica-negro-modelo-01.webp', 'capa-patagonica-negro-modelo-02.webp',
    'capa-patagonica-negro-modelo-03.webp', 'capa-patagonica-negro-modelo-04.webp', 'falda-suede-pampa-verde-modelo-03.webp', 'falda-suede-pampa-verde-modelo-04.webp',
    'falda-suede-pampa-verde-modelo-05.webp', 'falda-suede-pampa-verde-modelo-06.webp', 'jean-recto-ceibo-denim-claro-modelo-01.webp', 'jean-recto-ceibo-denim-claro-modelo-03.webp',
    'jean-recto-ceibo-denim-oscuro-modelo-01.webp', 'jean-recto-ceibo-denim-oscuro-modelo-02.webp', 'jean-recto-ceibo-denim-oscuro-modelo-03.webp', 'jean-recto-ceibo-denim-oscuro-modelo-06.webp',
    'jean-wide-leg-corrientes-denim-claro-modelo-01.webp', 'jean-wide-leg-corrientes-denim-claro-modelo-02.webp', 'jean-wide-leg-corrientes-denim-claro-modelo-05.webp', 'jean-wide-leg-corrientes-denim-claro-modelo-06.webp',
    'jean-wide-leg-corrientes-denim-oscuro-modelo-01.webp', 'jean-wide-leg-corrientes-denim-oscuro-modelo-02.webp', 'jogging-cafayate-blanco-modelo-01.webp', 'jogging-cafayate-blanco-modelo-03.webp',
    'jogging-cafayate-blanco-modelo-04.webp', 'jogging-cafayate-negro-modelo-01.webp', 'jogging-cafayate-negro-modelo-02.webp', 'jogging-cafayate-negro-modelo-04.webp',
    'jogging-cafayate-verde-modelo-01.webp', 'jogging-cafayate-verde-modelo-03.webp', 'jogging-cafayate-verde-modelo-04.webp', 'pantalon-ancho-barolo-marron-modelo-01.webp',
    'pantalon-ancho-barolo-marron-modelo-02.webp', 'pantalon-ancho-barolo-marron-modelo-03.webp', 'pantalon-ancho-barolo-marron-modelo-05.webp', 'pantalon-ancho-barolo-negro-modelo-01.webp',
    'pantalon-ancho-barolo-negro-modelo-02.webp', 'pantalon-ancho-barolo-negro-modelo-03.webp', 'pantalon-ancho-barolo-negro-modelo-05.webp', 'pantalon-ancho-barolo-negro-modelo-06.webp',
    'pantalon-sastrero-jacaranda-beige-modelo-01.webp', 'pantalon-sastrero-jacaranda-beige-modelo-02.webp', 'pantalon-sastrero-jacaranda-beige-modelo-03.webp', 'pantalon-sastrero-jacaranda-beige-modelo-04.webp',
    'pantalon-sastrero-jacaranda-gris-modelo-01.webp', 'polera-con-capucha-aconcagua-blanco-modelo-01.webp', 'polera-con-capucha-aconcagua-blanco-modelo-02.webp', 'polera-con-capucha-aconcagua-negro-modelo-01.webp',
    'polera-con-capucha-aconcagua-negro-modelo-02.webp', 'polera-con-capucha-aconcagua-negro-modelo-03.webp', 'polo-basico-trenque-lauquen-azul-modelo-02.webp', 'polo-basico-trenque-lauquen-azul-modelo-03.webp',
    'polo-basico-trenque-lauquen-blanco-modelo-01.webp', 'polo-basico-trenque-lauquen-blanco-modelo-04.webp', 'polo-basico-trenque-lauquen-blanco-modelo-05.webp', 'polo-basico-trenque-lauquen-blanco-modelo-06.webp',
    'polo-basico-trenque-lauquen-marron-modelo-03.webp', 'polo-basico-trenque-lauquen-marron-modelo-04.webp', 'polo-cuello-alto-ushuaia-guinda-modelo-04.webp', 'polo-cuello-cuadrado-ombu-negro-modelo-02.webp',
    'polo-cuello-cuadrado-ombu-negro-modelo-03.webp', 'polo-cuello-cuadrado-ombu-negro-modelo-04.webp', 'sweater-cuello-alto-bariloche-blanco-modelo-04.webp', 'sweater-cuello-alto-bariloche-gris-modelo-01.webp',
    'sweater-cuello-alto-bariloche-gris-modelo-03.webp', 'sweater-cuello-alto-bariloche-gris-modelo-04.webp', 'tapado-cordoba-gris-modelo-02.webp', 'tapado-cordoba-gris-modelo-04.webp',
    'tapado-cordoba-gris-modelo-05.webp', 'tapado-mara-con-cinturon-guinda-modelo-01.webp', 'tapado-mara-con-cinturon-guinda-modelo-02.webp', 'tapado-mara-con-cinturon-guinda-modelo-03.webp',
    'tapado-mara-con-cinturon-guinda-modelo-04.webp', 'tapado-mara-con-cinturon-guinda-modelo-05.webp', 'tapado-mara-con-cinturon-negro-modelo-01.webp', 'tapado-mara-con-cinturon-negro-modelo-02.webp',
    'tapado-mara-con-cinturon-negro-modelo-03.webp', 'tapado-mara-con-cinturon-negro-modelo-04.webp', 'tapado-mara-con-cinturon-negro-modelo-05.webp'
  ]);

  function imageFileName(value) {
    const raw = String(value || '').split('?')[0].split('#')[0];
    const lastSlash = raw.lastIndexOf('/');
    const name = lastSlash >= 0 ? raw.slice(lastSlash + 1) : raw;
    try {
      return decodeURIComponent(name)
        .replace(/^_\d+_/, '')
        .replace(/-(card|thumb)(?=\.(png|jpe?g|webp)$)/i, '')
        .replace(/\.(png|jpe?g|webp)$/i, '.webp')
        .toLowerCase();
    } catch (error) {
      return name
        .replace(/^_\d+_/, '')
        .replace(/-(card|thumb)(?=\.(png|jpe?g|webp)$)/i, '')
        .replace(/\.(png|jpe?g|webp)$/i, '.webp')
        .toLowerCase();
    }
  }

  function isYellowModel(value) {
    return yellowModelFiles.has(imageFileName(value));
  }

  function syncFrameImage(frame, image) {
    if (!frame || !image) return;
    const wasLoaded = frame.classList.contains('is-image-loaded');

    function markLoaded() {
      frame.classList.add('is-image-loaded');
    }

    if (image.complete) {
      markLoaded();
      return;
    }

    if (!wasLoaded) frame.classList.remove('is-image-loaded');
    image.addEventListener('load', markLoaded, { once: true });
    image.addEventListener('error', markLoaded, { once: true });
  }

  function applyToFrame(frame, imageUrl, image) {
    if (!frame) return;
    const yellow = isYellowModel(imageUrl);
    frame.classList.toggle('is-yellow-model', yellow);
    frame.style.setProperty('--model-bg-size', yellow ? 'auto 100%' : 'auto 150%');
    frame.style.setProperty('--model-bg-position', 'center center');
    syncFrameImage(frame, image || frame.querySelector('img'));
  }

  function applyCatalog(root) {
    const scope = root || document;
    scope.querySelectorAll('.catalog-card__image').forEach(function (frame) {
      const image = frame.querySelector('.catalog-card__img--primary') || frame.querySelector('img');
      applyToFrame(frame, image ? (image.currentSrc || image.src) : '', image);
    });
  }

  return {
    applyCatalog: applyCatalog,
    applyToFrame: applyToFrame,
    isYellowModel: isYellowModel,
    syncFrameImage: syncFrameImage
  };
})();

(function () {
  const cartForm = document.querySelector('[data-cart-form]');
  if (!cartForm) return;

  const subtotal = cartForm.querySelector('[data-cart-subtotal]');
  const moneyFormat = new Intl.NumberFormat('es-PE', {
    style: 'currency',
    currency: 'PEN',
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 2
  });
  let pendingChange = Promise.resolve();
  const checkoutPrefill = {
    'checkout[shipping_address][country]': 'PE',
    'checkout[shipping_address][country_code]': 'PE',
    'checkout[shipping_address][province]': 'Lima (Metropolitana)',
    'checkout[shipping_address][province_code]': 'PE-LMA',
    'checkout[shipping_address][city]': 'Lima Metropolitana',
    'checkout[shipping_address][zip]': '15000'
  };

  function formatMoney(cents) {
    return moneyFormat.format(Number(cents || 0) / 100).replace('PEN', 'S/.').replace('S/', 'S/.');
  }

  function buildCheckoutUrl() {
    const cartLines = Array.from(cartForm.querySelectorAll('[data-cart-item]'))
      .reduce(function (lines, item) {
        const variantId = item.dataset.cartVariantId || '';
        const quantityInput = item.querySelector('[data-cart-qty-input]');
        const quantity = Math.max(0, Number(quantityInput ? quantityInput.value : 0));
        if (!variantId || quantity < 1) return lines;
        lines.set(variantId, (lines.get(variantId) || 0) + quantity);
        return lines;
      }, new Map());
    const cartPath = Array.from(cartLines.entries())
      .map(function ([variantId, quantity]) {
        return variantId + ':' + quantity;
      })
      .join(',');
    const checkoutUrl = new URL(cartPath ? '/cart/' + cartPath : '/checkout', window.location.origin);
    Object.entries(checkoutPrefill).forEach(function ([key, value]) {
      checkoutUrl.searchParams.set(key, value);
    });
    return checkoutUrl.pathname + checkoutUrl.search;
  }

  async function syncQuantity(item, input) {
    const lineKey = item.dataset.cartLineKey || '';
    const quantity = Math.max(Number(input.getAttribute('min') || 0), Number(input.value || 0));
    if (!lineKey) return;

    input.value = String(quantity);
    item.classList.add('is-updating');
    pendingChange = fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart change failed');
        return response.json();
      })
      .then(function (cart) {
        const updatedLine = cart.items.find(function (cartItem) {
          return cartItem.key === lineKey;
        });
        if (!updatedLine || quantity === 0) {
          window.location.reload();
          return;
        }
        const price = item.querySelector('[data-cart-line-price]');
        if (price) price.textContent = formatMoney(updatedLine.final_line_price);
        if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
      })
      .catch(function () {
        window.location.reload();
      })
      .finally(function () {
        item.classList.remove('is-updating');
      });

    await pendingChange;
  }

  document.querySelectorAll('[data-cart-quantity]').forEach(function (control) {
    const input = control.querySelector('[data-cart-qty-input]');
    const minus = control.querySelector('[data-cart-qty-minus]');
    const plus = control.querySelector('[data-cart-qty-plus]');
    const item = control.closest('[data-cart-item]');
    if (!input) return;

    function setQuantity(delta) {
      const current = Number(input.value || 0);
      const min = Number(input.getAttribute('min') || 0);
      input.value = String(Math.max(min, current + delta));
      syncQuantity(item, input);
    }

    if (minus) minus.addEventListener('click', function () { setQuantity(-1); });
    if (plus) plus.addEventListener('click', function () { setQuantity(1); });
    input.addEventListener('change', function () { syncQuantity(item, input); });
  });

  cartForm.addEventListener('submit', function (event) {
    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    event.preventDefault();
    pendingChange.finally(function () {
      window.location.href = buildCheckoutUrl();
    });
  });
})();

(function () {
  const transparentNav = document.querySelector('[data-transparent-nav]');
  const transparentHero = document.querySelector('.hero');
  const nav = document.getElementById('mainNav');
  const hero = document.querySelector('.hero') || document.querySelector('.pdp-gallery');
  const mobileMenu = document.getElementById('mobileMenu');
  const hamburger = document.querySelector('.nav__hamburger');
  const ctNav = document.querySelector('.ct-v-nav');
  const ctMenuToggle = document.querySelector('[data-ct-menu-toggle]');
  const ctMobileMenu = document.querySelector('[data-ct-mobile-menu]');
  let menuOpen = false;
  let ctMenuOpen = false;

  function updateTransparentNav() {
    if (!transparentNav || !transparentHero) return;
    if (ctMenuOpen) {
      transparentNav.classList.remove('ct-v-nav--transparent');
      return;
    }
    const heroBottom = transparentHero.getBoundingClientRect().bottom;
    const navHeight = transparentNav.offsetHeight || 0;
    transparentNav.classList.toggle('ct-v-nav--transparent', heroBottom > navHeight);
  }

  function setCtMenuOpen(open) {
    if (!ctNav || !ctMenuToggle || !ctMobileMenu) return;
    ctMenuOpen = open;
    ctNav.classList.toggle('is-menu-open', ctMenuOpen);
    ctMenuToggle.classList.toggle('is-open', ctMenuOpen);
    ctMenuToggle.setAttribute('aria-expanded', String(ctMenuOpen));
    ctMenuToggle.setAttribute('aria-label', ctMenuOpen ? 'Cerrar menú' : 'Abrir menú');
    document.body.style.overflow = ctMenuOpen ? 'hidden' : '';
    updateTransparentNav();
  }

  function updateNav() {
    if (!nav || !hero) return;
    const heroBottom = hero.getBoundingClientRect().bottom;
    if (heroBottom <= window.innerHeight * 0.5) {
      nav.classList.remove('nav--transparent');
      nav.classList.add('nav--solid');
    } else {
      nav.classList.remove('nav--solid');
      nav.classList.add('nav--transparent');
    }
  }

  window.toggleMobileMenu = function toggleMobileMenu() {
    if (!mobileMenu || !hamburger || !nav) return;
    menuOpen = !menuOpen;
    mobileMenu.classList.toggle('open', menuOpen);
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    hamburger.classList.toggle('is-open', menuOpen);

    if (menuOpen) {
      nav.classList.remove('nav--transparent');
      nav.classList.add('nav--solid');
    } else {
      updateNav();
    }
  };

  window.addEventListener('scroll', updateNav, { passive: true });
  window.addEventListener('scroll', updateTransparentNav, { passive: true });
  if (ctMenuToggle) {
    ctMenuToggle.addEventListener('click', function () {
      setCtMenuOpen(!ctMenuOpen);
    });
  }
  if (ctMobileMenu) {
    ctMobileMenu.addEventListener('click', function (event) {
      if (event.target.closest('a')) setCtMenuOpen(false);
    });
  }
  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;
    const hash = link.getAttribute('href');
    if (!hash || hash === '#') return;
    const target = document.querySelector(hash);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    window.history.pushState(null, '', hash);
  });
  window.addEventListener('resize', function () {
    if (window.innerWidth > 768 && menuOpen) {
      menuOpen = false;
      mobileMenu.classList.remove('open');
      document.body.style.overflow = '';
      hamburger.classList.remove('is-open');
      updateNav();
    }
    if (window.innerWidth > 768 && ctMenuOpen) {
      setCtMenuOpen(false);
    }
    updateTransparentNav();
  });
  updateNav();
  updateTransparentNav();
  if (window.location.search.includes('customer_posted=true') || window.location.hash === '#contact_form') {
    window.history.replaceState(null, '', window.location.pathname || '/');
  }

  const grid = document.querySelector('.collection-grid');
  const track = document.querySelector('.collection-grid__track');
  if (!grid || !track) return;

  const arrowL = grid.querySelector('.carousel-arrow--left');
  const arrowR = grid.querySelector('.carousel-arrow--right');
  const mobileCarouselMq = window.matchMedia('(max-width: 900px)');
  let pos = 0;
  let dragging = false;
  let startX = 0;
  let dragStartPos = 0;
  let lastDragX = 0;
  let dragVelocity = 0;
  let didDrag = false;

  function maxPos() {
    const viewport = mobileCarouselMq.matches ? track : grid;
    return Math.max(0, track.scrollWidth - viewport.clientWidth);
  }
  function clampPos() {
    pos = Math.max(0, Math.min(pos, maxPos()));
  }
  function updateArrows() {
    if (!arrowL || !arrowR) return;
    const current = mobileCarouselMq.matches ? track.scrollLeft : pos;
    arrowL.style.opacity = current <= 5 ? '0' : '';
    arrowL.style.pointerEvents = current <= 5 ? 'none' : '';
    arrowR.style.opacity = current >= maxPos() - 5 ? '0' : '';
    arrowR.style.pointerEvents = current >= maxPos() - 5 ? 'none' : '';
  }
  function loop() {
    if (mobileCarouselMq.matches) {
      track.style.transform = '';
      updateArrows();
      requestAnimationFrame(loop);
      return;
    }
    if (!dragging && Math.abs(dragVelocity) > 0.5) {
      pos -= dragVelocity;
      dragVelocity *= 0.95;
    } else if (!dragging) {
      dragVelocity = 0;
    }
    clampPos();
    track.style.transform = 'translateX(' + (-pos) + 'px)';
    updateArrows();
    requestAnimationFrame(loop);
  }
  function getCardWidth() {
    const card = track.querySelector('.collection-card');
    return card ? card.offsetWidth + 2 : 300;
  }
  function smoothScroll(delta) {
    if (mobileCarouselMq.matches) {
      track.scrollBy({ left: delta, behavior: 'smooth' });
      window.setTimeout(updateArrows, 320);
      return;
    }
    const target = Math.max(0, Math.min(pos + delta, maxPos()));
    const start = pos;
    const duration = 400;
    const startTime = performance.now();
    dragVelocity = 0;
    function step(now) {
      const t = Math.min((now - startTime) / duration, 1);
      const ease = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
      pos = start + (target - start) * ease;
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  if (arrowL) arrowL.addEventListener('click', function (e) { e.stopPropagation(); smoothScroll(-getCardWidth()); });
  if (arrowR) arrowR.addEventListener('click', function (e) { e.stopPropagation(); smoothScroll(getCardWidth()); });

  grid.addEventListener('mousedown', function (e) {
    if (mobileCarouselMq.matches) return;
    if (e.target.closest('.carousel-arrow')) return;
    dragging = true;
    didDrag = false;
    grid.classList.add('is-dragging');
    startX = e.clientX;
    dragStartPos = pos;
    lastDragX = e.clientX;
    dragVelocity = 0;
    e.preventDefault();
  });
  window.addEventListener('mousemove', function (e) {
    if (!dragging) return;
    didDrag = true;
    dragVelocity = e.clientX - lastDragX;
    lastDragX = e.clientX;
    pos = dragStartPos - (e.clientX - startX);
  });
  window.addEventListener('mouseup', function () {
    if (!dragging) return;
    dragging = false;
    grid.classList.remove('is-dragging');
  });
  grid.addEventListener('touchstart', function (e) {
    if (mobileCarouselMq.matches) return;
    dragging = true;
    didDrag = false;
    startX = e.touches[0].clientX;
    dragStartPos = pos;
    lastDragX = e.touches[0].clientX;
    dragVelocity = 0;
  }, { passive: true });
  grid.addEventListener('touchmove', function (e) {
    if (mobileCarouselMq.matches) return;
    if (!dragging) return;
    didDrag = true;
    dragVelocity = e.touches[0].clientX - lastDragX;
    lastDragX = e.touches[0].clientX;
    pos = dragStartPos - (e.touches[0].clientX - startX);
  }, { passive: true });
  grid.addEventListener('touchend', function () { dragging = false; });
  grid.addEventListener('click', function (e) {
    if (didDrag) e.preventDefault();
  }, true);
  grid.addEventListener('wheel', function (e) {
    if (mobileCarouselMq.matches) return;
    if (Math.abs(e.deltaX) < 2) return;
    pos += e.deltaX;
    dragVelocity = 0;
    e.preventDefault();
  }, { passive: false });

  track.addEventListener('scroll', function () {
    if (!mobileCarouselMq.matches) return;
    updateArrows();
  }, { passive: true });
  if (mobileCarouselMq.addEventListener) {
    mobileCarouselMq.addEventListener('change', function () {
      dragging = false;
      dragVelocity = 0;
      pos = 0;
      track.style.transform = '';
      updateArrows();
    });
  }

  requestAnimationFrame(loop);
})();

(function () {
  const pdp = document.querySelector('[data-pdp]');
  if (!pdp) return;

  const track = pdp.querySelector('[data-pdp-gallery-track]');
  const prev = pdp.querySelector('[data-pdp-gallery-prev]');
  const next = pdp.querySelector('[data-pdp-gallery-next]');
  const dotsWrap = pdp.querySelector('[data-pdp-gallery-dots]');
  let dots = Array.from(pdp.querySelectorAll('[data-pdp-gallery-dot]'));
  const colorButtons = Array.from(pdp.querySelectorAll('[data-pdp-color]'));
  const colorLabel = pdp.querySelector('[data-pdp-color-label]');
  const sizeLabel = pdp.querySelector('[data-pdp-size-label]');
  const sizeError = pdp.querySelector('[data-pdp-size-error]');
  const sizeButtons = Array.from(pdp.querySelectorAll('[data-pdp-size]'));
  const variantInput = pdp.querySelector('[data-product-variant-id]');
  const variantsEl = pdp.querySelector('[data-pdp-variants]');
  const mediaEl = pdp.querySelector('[data-pdp-media]');
  const form = pdp.querySelector('form');
  const addCta = pdp.querySelector('[data-pdp-add-cta]');
  const waitlistForm = pdp.querySelector('[data-pdp-waitlist-tags]')?.closest('form');
  const waitlistTags = pdp.querySelector('[data-pdp-waitlist-tags]');
  const waitlistProductField = pdp.querySelector('[data-pdp-waitlist-product]');
  const waitlistColorField = pdp.querySelector('[data-pdp-waitlist-color]');
  const waitlistSizeField = pdp.querySelector('[data-pdp-waitlist-size]');
  const waitlistVariantField = pdp.querySelector('[data-pdp-waitlist-variant]');
  const waitlistBodyField = pdp.querySelector('[data-pdp-waitlist-body]');
  const waitlistStatus = pdp.querySelector('[data-pdp-waitlist-status]');
  const vestidorLink = pdp.querySelector('[data-pdp-vestidor-link]');
  const productTitle = (document.querySelector('.pdp-info__title')?.textContent || '').trim();
  const productId = pdp.dataset.productId || '';
  const productHandle = pdp.dataset.productHandle || normalizeText(productTitle);
  const forceSoldOut = pdp.dataset.forceSoldOut === 'true';
  const colorPosition = Number(pdp.dataset.colorPosition || 0);
  const sizePosition = Number(pdp.dataset.sizePosition || 0);
  let selectedColor = colorButtons[0] ? colorButtons[0].dataset.pdpColor : '';
  let selectedSize = '';
  let variants = [];
  let mediaItems = [];
  let renderedGalleryPageSize = 0;

  if (variantsEl) {
    try {
      variants = JSON.parse(variantsEl.textContent || '[]');
    } catch (error) {
      variants = [];
    }
  }

  if (mediaEl) {
    try {
      mediaItems = JSON.parse(mediaEl.textContent || '[]');
    } catch (error) {
      mediaItems = [];
    }
  }

  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function modelBgOpacityFor(seed, index) {
    const text = String(seed || productId || productHandle || 'casa-trame');
    let hash = 0;
    for (let i = 0; i < text.length; i += 1) {
      hash = (hash * 31 + text.charCodeAt(i)) % 9973;
    }
    return 60 + ((hash + (index * 7)) % 11);
  }

  function applyModelBgStyle(element, imageUrl, seed, index) {
    if (!element) return;
    element.style.setProperty('--model-bg-opacity', modelBgOpacityFor(seed, index) + '%');
    window.CTModelBackgrounds.applyToFrame(element, imageUrl);
  }

  function colorAliases(color) {
    const slug = normalizeText(color);
    if (!slug) return [];
    const aliases = [slug];
    const aliasMap = {
      black: 'negro',
      perla: 'blanco',
      blanco: 'perla',
      'gris-oscuro': 'gris',
      'azul-oscuro': 'azul',
      'verde-pacay': 'verde',
      'verde-botella': 'verde'
    };
    if (aliasMap[slug] && aliases.indexOf(aliasMap[slug]) === -1) aliases.push(aliasMap[slug]);
    return aliases;
  }

  function updateVestidorLink() {
    if (!vestidorLink || !productId) return;
    const itemId = selectedColor ? productId + '-' + normalizeText(selectedColor) : productId;
    const url = new URL(vestidorLink.getAttribute('href') || '/pages/vestidor', window.location.origin);
    url.searchParams.set('add', itemId);
    vestidorLink.href = url.pathname + url.search + url.hash;
  }

  function fallbackImageForColor(color) {
    const activeButton = colorButtons.find(function (button) {
      return button.dataset.pdpColor === color;
    });
    if (!activeButton || !activeButton.dataset.pdpImage) return [];
    if (!isModelImage({ url: activeButton.dataset.pdpImage })) return [];
    return [{
      url: activeButton.dataset.pdpImage,
      thumb: activeButton.dataset.pdpImage,
      alt: productTitle + ' — ' + color,
      width: 1200,
      height: 1500
    }];
  }

  function explicitGalleryForColor(color) {
    const activeButton = colorButtons.find(function (button) {
      return button.dataset.pdpColor === color;
    });
    if (!activeButton || !activeButton.dataset.pdpGallery) return [];
    return activeButton.dataset.pdpGallery.split('|').filter(Boolean).filter(function (url) {
      return isModelImage({ url: url });
    }).map(function (url, index) {
      return {
        url: url,
        thumb: url,
        alt: productTitle + ' — ' + color + ' — foto ' + (index + 1),
        width: 1200,
        height: 1500
      };
    });
  }

  function filenameFromUrl(url) {
    return String(url || '').split('/').pop().split('?')[0];
  }

  function isModelImage(item) {
    const filename = filenameFromUrl(item && (item.filename || item.url || item.thumb));
    const haystack = normalizeText([filename, item && item.url, item && item.alt].join(' '));
    return haystack.indexOf('-modelo-') !== -1 || haystack.indexOf('modelo-') !== -1;
  }

  function variantForColor(color) {
    if (!colorPosition || !color) return null;
    return variants.find(function (variant) {
      return optionValue(variant, colorPosition) === color && variant.featured_image && variant.featured_image.src;
    }) || null;
  }

  function imagesFromVariantBlock(color) {
    if (!mediaItems.length || !variants.length || !colorPosition) return [];

    const starts = colorButtons.map(function (button) {
      const variant = variantForColor(button.dataset.pdpColor || '');
      if (!variant || !variant.featured_image) return null;
      const filename = filenameFromUrl(variant.featured_image.src);
      const index = mediaItems.findIndex(function (item) {
        return item.filename === filename || filenameFromUrl(item.url) === filename;
      });
      return index >= 0 ? { color: button.dataset.pdpColor, index } : null;
    }).filter(Boolean).sort(function (a, b) {
      return a.index - b.index;
    });

    const current = starts.find(function (item) {
      return item.color === color;
    });
    if (!current) return [];

    const next = starts.find(function (item) {
      return item.index > current.index;
    });
    return mediaItems.slice(current.index, next ? next.index : mediaItems.length).filter(isModelImage);
  }

  function imagesForColor(color) {
    const explicitGallery = explicitGalleryForColor(color);
    if (explicitGallery.length) return explicitGallery;

    const aliases = colorAliases(color);
    const matches = mediaItems.filter(function (item) {
      if (!isModelImage(item)) return false;
      const haystack = normalizeText([item.alt, item.filename, item.url].join(' '));
      return aliases.some(function (alias) {
        return haystack.indexOf(alias) !== -1;
      });
    });
    if (matches.length) return matches;

    const variantBlock = imagesFromVariantBlock(color);
    if (variantBlock.length) return variantBlock;

    return fallbackImageForColor(color);
  }

  function renderDots(count) {
    if (!dotsWrap) return;
    dotsWrap.innerHTML = '';
    for (let index = 0; index < count; index += 1) {
      const dot = document.createElement('button');
      dot.className = 'pdp-gallery__dot' + (index === 0 ? ' active' : '');
      dot.type = 'button';
      dot.dataset.pdpGalleryDot = String(index);
      dot.setAttribute('aria-label', 'Ir a grupo de fotos ' + (index + 1));
      dotsWrap.appendChild(dot);
    }
    dots = Array.from(dotsWrap.querySelectorAll('[data-pdp-gallery-dot]'));
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goToSlide(Number(dot.dataset.pdpGalleryDot || 0));
      });
    });
  }

  function renderGallery(color) {
    if (!track) return;
    const images = imagesForColor(color);
    if (!images.length) return;
    const pageSize = slidesPerPage();
    track.innerHTML = '';
    images.forEach(function (item, index) {
      let page = track.lastElementChild;
      if (!page || !page.classList.contains('pdp-gallery__page') || page.children.length >= pageSize) {
        page = document.createElement('div');
        page.className = 'pdp-gallery__page';
        track.appendChild(page);
      }
      const slide = document.createElement('div');
      const img = document.createElement('img');
      slide.className = 'pdp-gallery__slide';
      applyModelBgStyle(slide, item.url, color + ' ' + item.url, index);
      img.src = item.url;
      img.alt = item.alt || (productTitle + ' — ' + color);
      img.width = item.width || 1200;
      img.height = item.height || 1500;
      img.loading = index === 0 ? 'eager' : 'lazy';
      img.decoding = 'async';
      if ('fetchPriority' in img) img.fetchPriority = index === 0 ? 'high' : 'low';
      img.dataset.frame = 'product';
      slide.appendChild(img);
      window.CTModelBackgrounds.syncFrameImage(slide, img);
      page.appendChild(slide);
    });
    track.classList.toggle('pdp-gallery__pair--single', images.length <= 1);
    renderedGalleryPageSize = pageSize;
    const pageCount = pageCountForSlides(images.length);
    renderDots(pageCount);
    const hasMultiple = pageCount > 1;
    if (prev) {
      prev.hidden = !hasMultiple;
      prev.disabled = true;
    }
    if (next) {
      next.hidden = !hasMultiple;
      next.disabled = !hasMultiple;
    }
    if (dotsWrap) dotsWrap.hidden = !hasMultiple;
    goToSlide(0, 'auto');
    window.requestAnimationFrame(updateGallery);
  }

  function optionValue(variant, position) {
    if (!variant || !position) return '';
    return variant['option' + position] || '';
  }

  function variantIsAvailable(variant) {
    if (forceSoldOut) return false;
    return Boolean(variant && (variant.available || variant.available_for_sale));
  }

  function hasAnyAvailableVariant() {
    return variants.some(variantIsAvailable);
  }

  function variantMatchesColor(variant, color) {
    return !colorPosition || !color || optionValue(variant, colorPosition) === color;
  }

  function variantMatchesSize(variant, size) {
    return !sizePosition || !size || optionValue(variant, sizePosition) === size;
  }

  function variantById(id) {
    if (!id) return null;
    return variants.find(function (variant) {
      return String(variant.id) === String(id);
    }) || null;
  }

  function variantsForColor(color) {
    return variants.filter(function (variant) {
      return variantMatchesColor(variant, color);
    });
  }

  function availableSizesForColor(color) {
    if (!sizePosition) return [];
    return variantsForColor(color).reduce(function (sizes, variant) {
      const size = optionValue(variant, sizePosition);
      if (variantIsAvailable(variant) && size && sizes.indexOf(size) === -1) sizes.push(size);
      return sizes;
    }, []);
  }

  function onlyAvailableSizeForColor(color) {
    const sizes = availableSizesForColor(color);
    return sizes.length === 1 ? sizes[0] : '';
  }

  function sizeIsAvailable(size) {
    if (!sizePosition) return true;
    return variants.some(function (variant) {
      return variantMatchesColor(variant, selectedColor) && variantMatchesSize(variant, size) && variantIsAvailable(variant);
    });
  }

  function preferredVariantForColor(color, preferredSize) {
    const colorVariants = variantsForColor(color);
    if (!colorVariants.length) return null;

    const preferredAvailable = colorVariants.find(function (variant) {
      return variantIsAvailable(variant) && variantMatchesSize(variant, preferredSize);
    });
    if (preferredAvailable) return preferredAvailable;

    return colorVariants.find(variantIsAvailable) || colorVariants[0] || null;
  }

  function syncColorUi() {
    const activeColor = colorButtons.find(function (button) {
      return button.dataset.pdpColor === selectedColor;
    }) || colorButtons[0];
    if (!activeColor) return;

    selectedColor = activeColor.dataset.pdpColor || selectedColor;
    if (colorLabel) colorLabel.textContent = activeColor.dataset.pdpColorDisplay || selectedColor;
    colorButtons.forEach(function (button) {
      button.classList.toggle('active', button === activeColor);
    });
  }

  function syncSizeUi() {
    if (sizeLabel) sizeLabel.textContent = selectedSize ? 'Talla ' + selectedSize : 'Selecciona una talla';
    if (sizeError) sizeError.classList.remove('show');
    sizeButtons.forEach(function (button) {
      const size = button.dataset.pdpSize || '';
      const available = sizeIsAvailable(size);
      const label = size + (available ? '' : ' agotado');
      const isActive = Boolean(selectedSize) && button.dataset.pdpSize === selectedSize;
      button.classList.toggle('is-active', isActive);
      button.classList.toggle('is-unavailable', !available);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      button.setAttribute('aria-label', label);
      button.title = available ? size : size + ' agotado';
    });
  }

  function selectBestInitialVariant() {
    const currentVariant = variantById(variantInput ? variantInput.value : '');
    const availableVariant = variants.find(variantIsAvailable) || null;
    const baseVariant = currentVariant || availableVariant || variants[0] || null;
    if (!baseVariant) return null;

    if (colorPosition) selectedColor = optionValue(baseVariant, colorPosition) || selectedColor;
    selectedSize = onlyAvailableSizeForColor(selectedColor);
    const preferredSize = selectedSize;
    const colorVariant = preferredVariantForColor(selectedColor, preferredSize);

    return colorVariant || baseVariant;
  }

  function promptWaitlistIfNeeded(variant, options) {
    if (variantIsAvailable(variant) || !waitlistForm) return;
    if (hasAnyAvailableVariant() && sizeButtons.length && !selectedSize) return;

    waitlistForm.hidden = false;
    waitlistForm.classList.remove('is-hidden');
    setWaitlistStatus('Déjanos tu email y te avisaremos cuando vuelva a estar disponible.', false);
    const emailInput = waitlistForm.querySelector('input[type="email"]');
    if (emailInput && options && options.focus) {
      window.requestAnimationFrame(function () {
        emailInput.focus({ preventScroll: true });
      });
    }
  }

  function updateVariant() {
    if (!variantInput || !variants.length) return null;
    const match = variants.find(function (variant) {
      return variantMatchesColor(variant, selectedColor) && variantMatchesSize(variant, selectedSize);
    });
    if (match) variantInput.value = match.id;
    updatePurchaseState(match);
    return match || null;
  }

  function updatePurchaseState(variant) {
    if (forceSoldOut) {
      if (addCta) {
        addCta.hidden = false;
        addCta.disabled = true;
        addCta.textContent = 'Agotado';
      }
      if (waitlistForm) {
        waitlistForm.hidden = false;
        waitlistForm.classList.remove('is-hidden');
      }
      if (waitlistTags) {
        const tags = ['waitlist', 'waitlist-' + productHandle, 'agotado'];
        if (selectedColor) tags.push('color-' + normalizeText(selectedColor));
        if (selectedSize) tags.push('talla-' + normalizeText(selectedSize));
        if (variant && variant.id) tags.push('variant-' + variant.id);
        waitlistTags.value = tags.join(', ');
      }
      updateWaitlistDetails(variant);
      return;
    }

    const anyAvailable = hasAnyAvailableVariant();
    const waitingForSize = Boolean(anyAvailable && sizeButtons.length && !selectedSize);
    const isAvailable = variantIsAvailable(variant);

    if (addCta) {
      addCta.hidden = !anyAvailable || (!waitingForSize && !isAvailable);
      addCta.disabled = !anyAvailable || (!waitingForSize && !isAvailable);
      addCta.textContent = isAvailable || waitingForSize ? 'Añadir al Carrito' : 'Agotado';
    }

    if (waitlistForm) {
      const hasServerStatus = Boolean(waitlistStatus && waitlistStatus.hasAttribute('data-pdp-waitlist-server-status'));
      if (!hasServerStatus && anyAvailable && (waitingForSize || isAvailable) && waitlistStatus && waitlistStatus.textContent.trim()) {
        setWaitlistStatus('', false);
      }
      const hasFeedback = Boolean(waitlistStatus && !waitlistStatus.hidden && waitlistStatus.textContent.trim());
      const shouldHideWaitlist = !hasFeedback && anyAvailable && (waitingForSize || isAvailable);
      waitlistForm.hidden = shouldHideWaitlist;
      waitlistForm.classList.toggle('is-hidden', shouldHideWaitlist);
    }

    if (waitlistTags) {
      const tags = ['waitlist'];
      tags.push('waitlist-' + productHandle);
      if (selectedColor) tags.push('color-' + normalizeText(selectedColor));
      if (selectedSize) tags.push('talla-' + normalizeText(selectedSize));
      if (variant && variant.id) tags.push('variant-' + variant.id);
      waitlistTags.value = tags.join(', ');
    }

    updateWaitlistDetails(variant);
  }

  function setWaitlistStatus(message, isError) {
    if (!waitlistStatus) return;
    waitlistStatus.removeAttribute('data-pdp-waitlist-server-status');
    waitlistStatus.textContent = message;
    waitlistStatus.hidden = !message;
    waitlistStatus.classList.toggle('pdp-waitlist__status--error', Boolean(isError));
  }

  function setWaitlistField(field, value) {
    if (field) field.value = value || '';
  }

  function updateWaitlistDetails(variant) {
    if (!waitlistForm) return;
    const variantId = variant && variant.id ? String(variant.id) : (variantInput ? String(variantInput.value || '') : '');
    const summary = [
      'Lista de espera',
      productTitle,
      selectedColor ? 'Color: ' + selectedColor : '',
      selectedSize ? 'Talla: ' + selectedSize : '',
      variantId ? 'Variante: ' + variantId : ''
    ].filter(Boolean).join(' | ');

    setWaitlistField(waitlistProductField, productTitle);
    setWaitlistField(waitlistColorField, selectedColor);
    setWaitlistField(waitlistSizeField, selectedSize);
    setWaitlistField(waitlistVariantField, variantId);
    setWaitlistField(waitlistBodyField, summary);
  }

  function submitWaitlist(event) {
    if (!waitlistForm) return;

    const emailInput = waitlistForm.querySelector('input[type="email"]');
    const emailValue = emailInput ? String(emailInput.value || '').trim() : '';
    if (emailInput && (!emailValue || !emailInput.checkValidity())) {
      event.preventDefault();
      event.stopPropagation();
      emailInput.classList.add('is-invalid');
      setWaitlistStatus('Ingresa un email válido para avisarte cuando vuelva a estar disponible.', true);
      emailInput.focus();
      return;
    }
    if (emailInput) emailInput.classList.remove('is-invalid');

    updateWaitlistDetails(variantById(variantInput ? variantInput.value : ''));

    const submitButton = waitlistForm.querySelector('button[type="submit"]');
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Anotando...';
    }
    setWaitlistStatus('Enviando...', false);
  }

  function gallerySlides() {
    if (!track) return [];
    const slides = Array.from(track.querySelectorAll('.pdp-gallery__slide'));
    if (slides.length) return slides;
    return Array.from(track.children).filter(function (child) {
      return child.tagName === 'IMG';
    });
  }

  function galleryPages() {
    if (!track) return [];
    return Array.from(track.children).filter(function (child) {
      return child.classList.contains('pdp-gallery__page');
    });
  }

  function currentSlideIndex() {
    if (!track) return 0;
    const slideCount = gallerySlides().length;
    const pageCount = pageCountForSlides(slideCount);
    let closestIndex = 0;
    let closestDistance = Infinity;
    for (let index = 0; index < pageCount; index += 1) {
      const distance = Math.abs(track.scrollLeft - pageOffset(index));
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    }
    return closestIndex;
  }

  function slidesPerPage() {
    return window.matchMedia('(max-width: 768px)').matches ? 1 : 2;
  }

  function pageCountForSlides(count) {
    return Math.max(1, Math.ceil(count / slidesPerPage()));
  }

  function pageOffset(index) {
    const pages = galleryPages();
    if (!pages.length) return 0;
    const pageIndex = Math.min(pages.length - 1, Math.max(0, index));
    return pages[pageIndex] ? pages[pageIndex].offsetLeft : 0;
  }

  function updateGallery() {
    if (!track) return;
    const slideCount = gallerySlides().length;
    const pageCount = pageCountForSlides(slideCount);
    const current = Math.min(pageCount - 1, Math.max(0, currentSlideIndex()));
    dots.forEach(function (dot, index) {
      dot.classList.toggle('active', index === current);
    });
    if (prev) prev.disabled = current <= 0;
    if (next) next.disabled = current >= pageCount - 1;
  }

  function goToSlide(index, behavior) {
    if (!track) return;
    const pageCount = pageCountForSlides(gallerySlides().length);
    const nextIndex = Math.min(pageCount - 1, Math.max(0, index));
    const left = pageOffset(nextIndex);
    if (typeof track.scrollTo === 'function') {
      track.scrollTo({ left: left, behavior: behavior || 'smooth' });
    } else {
      track.scrollLeft = left;
    }
    if (behavior === 'auto') track.scrollLeft = left;
    window.requestAnimationFrame(updateGallery);
    window.setTimeout(updateGallery, 260);
  }

  function enableDragScroll() {
    if (!track || !window.PointerEvent) return;

    let pointerDown = false;
    let dragging = false;
    let startX = 0;
    let startY = 0;
    let startScrollLeft = 0;

    function endDrag(event) {
      if (!pointerDown) return;
      if (dragging) {
        track.classList.remove('is-dragging');
        goToSlide(currentSlideIndex());
        if (event && track.releasePointerCapture) {
          try { track.releasePointerCapture(event.pointerId); } catch (error) {}
        }
      }
      pointerDown = false;
      dragging = false;
    }

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.pointerType !== 'mouse') return;
      pointerDown = true;
      dragging = false;
      startX = event.clientX;
      startY = event.clientY;
      startScrollLeft = track.scrollLeft;
    });

    track.addEventListener('pointermove', function (event) {
      if (!pointerDown) return;
      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;

      if (!dragging) {
        if (Math.abs(deltaX) < 8 && Math.abs(deltaY) < 8) return;
        if (Math.abs(deltaY) > Math.abs(deltaX)) {
          endDrag(event);
          return;
        }
        dragging = true;
        track.classList.add('is-dragging');
        if (track.setPointerCapture) {
          try { track.setPointerCapture(event.pointerId); } catch (error) {}
        }
      }

      event.preventDefault();
      track.scrollLeft = startScrollLeft - deltaX;
      updateGallery();
    });

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', endDrag);
  }

  function refreshGalleryForLayout() {
    const nextGalleryPageSize = slidesPerPage();
    if (nextGalleryPageSize === renderedGalleryPageSize) {
      goToSlide(currentSlideIndex(), 'auto');
      updateGallery();
      return;
    }
    renderGallery(selectedColor);
  }

  if (track) track.addEventListener('scroll', updateGallery, { passive: true });
  if (prev) prev.addEventListener('click', function () { goToSlide(currentSlideIndex() - 1); });
  if (next) next.addEventListener('click', function () { goToSlide(currentSlideIndex() + 1); });
  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      goToSlide(Number(dot.dataset.pdpGalleryDot || 0));
    });
  });

  selectBestInitialVariant();
  syncColorUi();
  syncSizeUi();
  renderGallery(selectedColor);
  enableDragScroll();

  let resizeTimer = null;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(refreshGalleryForLayout, 120);
  });

  colorButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      selectedColor = button.dataset.pdpColor || '';
      if (colorLabel) colorLabel.textContent = button.dataset.pdpColorDisplay || selectedColor;
      colorButtons.forEach(function (item) {
        item.classList.toggle('active', item === button);
      });
      setWaitlistStatus('', false);
      selectedSize = onlyAvailableSizeForColor(selectedColor);
      syncSizeUi();
      renderGallery(selectedColor);
      promptWaitlistIfNeeded(updateVariant());
      updateVestidorLink();
    });
  });

  sizeButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      setWaitlistStatus('', false);
      selectedSize = button.dataset.pdpSize || '';
      syncSizeUi();
      promptWaitlistIfNeeded(updateVariant());
    });
  });

  if (form) {
    form.addEventListener('submit', function (event) {
      if (sizeButtons.length && !selectedSize) {
        event.preventDefault();
        if (sizeError) sizeError.classList.add('show');
      }
    });
  }

  if (waitlistForm) {
    waitlistForm.addEventListener('submit', submitWaitlist, true);
  }

  const initialVariant = updateVariant();
  promptWaitlistIfNeeded(initialVariant);
  updateVestidorLink();
  updateGallery();
})();

(function () {
  const detail = document.querySelector('[data-product-detail]');
  if (!detail) return;

  const heroImage = detail.querySelector('[data-product-hero-image]');
  const imageFrame = detail.querySelector('.product-detail__image-frame');
  const variantInput = detail.querySelector('[data-product-variant-id]');

  function syncDetailModelBg(imageUrl) {
    const currentImageUrl = imageUrl || (heroImage ? (heroImage.currentSrc || heroImage.src) : '');
    window.CTModelBackgrounds.applyToFrame(imageFrame, currentImageUrl);
  }

  syncDetailModelBg();

  detail.querySelectorAll('[data-product-color]').forEach(function (button) {
    button.addEventListener('click', function () {
      const imageUrl = button.dataset.image || '';
      const variantId = button.dataset.variantId || '';

      if (heroImage && imageUrl) heroImage.src = imageUrl;
      syncDetailModelBg(imageUrl);
      if (variantInput && variantId) variantInput.value = variantId;

      detail.querySelectorAll('[data-product-color]').forEach(function (swatch) {
        swatch.classList.toggle('is-active', swatch === button);
      });
    });
  });
})();

(function () {
  const section = document.querySelector('[data-ct-collection]');
  if (!section) return;

  const cards = Array.from(section.querySelectorAll('[data-product-card]'));
  const filterButtons = Array.from(section.querySelectorAll('[data-filter]'));
  const countEl = section.querySelector('[data-visible-count]');
  const emptyState = section.querySelector('[data-empty-state]');
  const grid = section.querySelector('[data-product-grid]');
  const gridButtons = Array.from(section.querySelectorAll('[data-grid-cols]'));
  const toggleButtons = Array.from(section.querySelectorAll('[data-toggle-target]'));
  const togglePanels = Array.from(section.querySelectorAll('[data-toggle-panel]'));
  const modal = section.querySelector('[data-quick-modal]');
  const favoriteStorageKey = 'casa-trame-favorites-v1';

  function readFavorites() {
    try {
      const parsed = JSON.parse(localStorage.getItem(favoriteStorageKey) || '[]');
      return Array.isArray(parsed) ? parsed.map(String) : [];
    } catch (error) {
      return [];
    }
  }

  function writeFavorites(ids) {
    const uniqueIds = Array.from(new Set(ids.map(String).filter(Boolean)));
    try {
      localStorage.setItem(favoriteStorageKey, JSON.stringify(uniqueIds));
      window.dispatchEvent(new CustomEvent('ct:favorites-changed'));
    } catch (error) {
      // Favoritos son una mejora local; si el navegador bloquea storage, no rompemos el catálogo.
    }
  }

  function updateFavoriteButton(card) {
    const button = card && card.querySelector('[data-favorite-toggle]');
    if (!button) return;
    const favoriteId = String(card.dataset.favoriteId || '');
    const isActive = favoriteId && readFavorites().includes(favoriteId);
    button.classList.toggle('is-active', Boolean(isActive));
    button.setAttribute('aria-pressed', String(Boolean(isActive)));
    button.setAttribute('aria-label', isActive ? 'Quitar de favoritos' : 'Guardar en favoritos');
  }

  function toggleFavorite(card) {
    const favoriteId = String(card && card.dataset.favoriteId ? card.dataset.favoriteId : '');
    if (!favoriteId) return;
    const favorites = readFavorites();
    const nextFavorites = favorites.includes(favoriteId)
      ? favorites.filter(function (id) { return id !== favoriteId; })
      : favorites.concat(favoriteId);
    writeFavorites(nextFavorites);
    updateFavoriteButton(card);
  }

  function sortCatalogCards() {
    if (!grid || !cards.length) return;
    cards
      .slice()
      .sort(function (a, b) {
        const availableA = a.dataset.available === 'true' ? 0 : 1;
        const availableB = b.dataset.available === 'true' ? 0 : 1;
        if (availableA !== availableB) return availableA - availableB;
        return (a.dataset.title || '').localeCompare(b.dataset.title || '', 'es', { sensitivity: 'base' });
      })
      .forEach(function (card) {
        grid.appendChild(card);
      });
  }

  function parseCardGallery(value) {
    return String(value || '')
      .split('|')
      .map(function (url) {
        return url.trim();
      })
      .filter(Boolean);
  }

  function assetFileName(value) {
    return String(value || '').split('?')[0].split('#')[0].split('/').pop();
  }

  function sameAssetUrl(image, nextUrl) {
    if (!image || !nextUrl) return false;
    const nextFile = assetFileName(nextUrl);
    const currentFile = assetFileName(image.currentSrc || image.src || image.getAttribute('src'));
    if (nextFile && currentFile && nextFile === currentFile) return true;
    try {
      const next = new URL(nextUrl, window.location.href).href;
      const current = new URL(image.currentSrc || image.src || image.getAttribute('src') || '', window.location.href).href;
      return next === current;
    } catch (error) {
      return false;
    }
  }

  function setImageSource(image, nextUrl) {
    if (!image || !nextUrl || sameAssetUrl(image, nextUrl)) return false;
    image.dataset.pendingSrc = nextUrl;

    function commit() {
      if (image.dataset.pendingSrc !== nextUrl) return;
      image.src = nextUrl;
      delete image.dataset.pendingSrc;
    }

    const preload = new Image();
    preload.decoding = 'async';
    preload.onload = commit;
    preload.onerror = commit;
    preload.src = nextUrl;
    if (preload.complete) commit();
    return true;
  }

  function activeCardImage(card) {
    if (!card) return null;
    return card.querySelector('.catalog-card__img.is-active') ||
      card.querySelector('.catalog-card__img--primary') ||
      card.querySelector('.catalog-card__img');
  }

  function inactiveCardImage(card) {
    if (!card) return null;
    const active = activeCardImage(card);
    return Array.from(card.querySelectorAll('.catalog-card__img')).find(function (image) {
      return image !== active;
    }) || null;
  }

  function afterImageDecode(image, callback) {
    if (!image || typeof callback !== 'function') return;
    if (typeof image.decode === 'function') {
      image.decode().catch(function () {}).then(callback);
      return;
    }
    callback();
  }

  function preloadImage(nextUrl, callback) {
    if (!nextUrl || typeof callback !== 'function') return;
    const preload = new Image();
    let finished = false;

    function finish() {
      if (finished) return;
      finished = true;
      afterImageDecode(preload, callback);
    }

    preload.decoding = 'async';
    preload.onload = finish;
    preload.onerror = finish;
    preload.src = nextUrl;
    if (preload.complete) finish();
  }

  function swapCardImage(card, nextUrl) {
    if (!card || !nextUrl) return false;

    const active = activeCardImage(card);
    const inactive = inactiveCardImage(card);

    if (active && sameAssetUrl(active, nextUrl)) {
      delete card.dataset.pendingImageSrc;
      return false;
    }

    if (!card.classList.contains('catalog-card--has-gallery') || !active || !inactive) {
      setImageSource(active, nextUrl);
      setImageSource(inactive, nextUrl);
      return true;
    }

    card.dataset.pendingImageSrc = nextUrl;
    preloadImage(nextUrl, function () {
      if (card.dataset.pendingImageSrc !== nextUrl) return;

      inactive.src = nextUrl;
      inactive.alt = active.alt || inactive.alt || '';
      afterImageDecode(inactive, function () {
        if (card.dataset.pendingImageSrc !== nextUrl) return;

        inactive.classList.add('is-active');
        active.classList.remove('is-active');
        delete card.dataset.pendingImageSrc;

        const imageFrame = card.querySelector('.catalog-card__image');
        window.CTModelBackgrounds.syncFrameImage(imageFrame, inactive);
      });
    });

    return true;
  }

  function cardModelBgOpacity(seed, index) {
    const text = String(seed || 'casa-trame');
    let hash = 0;
    for (let i = 0; i < text.length; i += 1) {
      hash = (hash * 31 + text.charCodeAt(i)) % 9973;
    }
    return 60 + ((hash + (index * 7)) % 11);
  }

  function applyCardModelBg(card, seed, index) {
    const imageFrame = card && card.querySelector('.catalog-card__image');
    if (!imageFrame) return;
    const image = imageFrame.querySelector('.catalog-card__img.is-active') ||
      imageFrame.querySelector('.catalog-card__img--primary') ||
      imageFrame.querySelector('img');
    const imageUrl = card.dataset.image || seed;
    imageFrame.style.setProperty('--model-bg-opacity', cardModelBgOpacity(seed || card.dataset.title || '', 0) + '%');
    window.CTModelBackgrounds.applyToFrame(imageFrame, imageUrl, image);
  }

  function copyModelBgVars(source, target) {
    if (!source || !target) return;
    const computed = window.getComputedStyle(source);
    ['--model-bg-opacity', '--model-bg-size', '--model-bg-position'].forEach(function (name) {
      const value = computed.getPropertyValue(name).trim();
      if (value) target.style.setProperty(name, value);
    });
  }

  cards.forEach(function (card) {
    applyCardModelBg(card, [card.dataset.title, card.dataset.currentColorDisplay].filter(Boolean).join(' '), 0);
  });

  function updateCardGalleryControls(card, gallery) {
    if (!card) return;

    const images = gallery || parseCardGallery(card.dataset.gallery);
    const hasGallery = images.length > 0;
    const hasControls = images.length > 1;
    const currentIndex = Math.min(
      Math.max(Number.parseInt(card.dataset.galleryIndex || '0', 10) || 0, 0),
      Math.max(images.length - 1, 0)
    );

    card.classList.toggle('catalog-card--has-gallery', hasGallery);
    card.dataset.galleryIndex = String(currentIndex);

    if (hasGallery) {
      const active = activeCardImage(card);
      if (active) active.classList.add('is-active');
    } else {
      card.querySelectorAll('.catalog-card__img.is-active').forEach(function (image) {
        image.classList.remove('is-active');
      });
    }

    const prev = card.querySelector('[data-card-gallery-prev]');
    const next = card.querySelector('[data-card-gallery-next]');

    if (prev) {
      const disabledPrev = !hasControls || currentIndex <= 0;
      prev.hidden = !hasControls;
      prev.disabled = false;
      prev.classList.toggle('is-disabled', disabledPrev);
      prev.setAttribute('aria-disabled', disabledPrev ? 'true' : 'false');
      prev.tabIndex = disabledPrev ? -1 : 0;
    }

    if (next) {
      const disabledNext = !hasControls || currentIndex >= images.length - 1;
      next.hidden = !hasControls;
      next.disabled = false;
      next.classList.toggle('is-disabled', disabledNext);
      next.setAttribute('aria-disabled', disabledNext ? 'true' : 'false');
      next.tabIndex = disabledNext ? -1 : 0;
    }
  }

  function setCardGalleryIndex(card, index) {
    if (!card) return;

    const gallery = parseCardGallery(card.dataset.gallery);
    if (!gallery.length) return;

    const nextIndex = Math.min(Math.max(index, 0), gallery.length - 1);
    const nextImage = gallery[nextIndex];
    const modalGallery = parseCardGallery(card.dataset.modalGallery);
    const nextModalImage = modalGallery[nextIndex] || nextImage;

    swapCardImage(card, nextImage);

    card.dataset.galleryIndex = String(nextIndex);
    card.dataset.image = nextModalImage;
    applyCardModelBg(card, [card.dataset.title, card.dataset.currentColorDisplay].filter(Boolean).join(' '), 0);
    updateCardGalleryControls(card, gallery);
  }

  function setCardColor(card, button) {
    if (!card || !button) return;

    const colorGallery = parseCardGallery(button.dataset.colorGallery);
    const colorModalGallery = parseCardGallery(button.dataset.colorModalGallery);
    const imageUrl = colorGallery[0] || button.dataset.colorImage || '';
    const modalImageUrl = colorModalGallery[0] || button.dataset.colorModalImage || imageUrl;
    const colorUrl = button.dataset.colorUrl || card.dataset.url || '#';
    const variantId = button.dataset.variantId || '';
    const colorName = button.dataset.colorName || '';
    const colorDisplay = button.dataset.colorDisplay || colorName;
    const imageLink = card.querySelector('.catalog-card__image-link');
    const textLink = card.querySelector('.catalog-card__text');

    if (imageLink) imageLink.href = colorUrl;
    if (textLink) textLink.href = colorUrl;

    card.dataset.image = modalImageUrl;
    card.dataset.gallery = colorGallery.join('|');
    card.dataset.modalGallery = colorModalGallery.join('|');
    card.dataset.galleryIndex = '0';
    card.dataset.url = colorUrl;
    if (variantId) card.dataset.variantId = variantId;
    if (button.dataset.favoriteId) card.dataset.favoriteId = button.dataset.favoriteId;
    card.dataset.currentColor = colorName;
    card.dataset.currentColorDisplay = colorDisplay;
    updateCardGalleryControls(card, colorGallery);
    swapCardImage(card, imageUrl);
    applyCardModelBg(card, [card.dataset.title, colorDisplay].filter(Boolean).join(' '), 0);
    updateFavoriteButton(card);

    card.querySelectorAll('[data-color-swatch]').forEach(function (swatch) {
      swatch.classList.toggle('is-active', swatch === button);
    });
  }

  function updateVisibleCount() {
    if (!countEl) return;
    const visibleCards = cards.filter(function (card) {
      return !card.hidden;
    });
    countEl.textContent = String(visibleCards.length);
    if (emptyState) emptyState.hidden = visibleCards.length !== 0;
  }

  function normalizeFilterValue(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, ' y ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function filterExists(filterValue) {
    return filterButtons.some(function (button) {
      return button.dataset.filter === filterValue;
    });
  }

  function getUrlFilter() {
    const params = new URLSearchParams(window.location.search);
    const rawFilter = params.get('categoria') || params.get('category') || '';
    let normalizedFilter = normalizeFilterValue(rawFilter);
    if (['polera', 'poleras', 'sweater', 'sweaters'].indexOf(normalizedFilter) !== -1) {
      normalizedFilter = 'poleras-y-sweaters';
    }
    return normalizedFilter && filterExists(normalizedFilter) ? normalizedFilter : 'all';
  }

  function syncUrlFilter(filterValue) {
    if (!window.history || !window.history.replaceState) return;
    const url = new URL(window.location.href);
    if (filterValue && filterValue !== 'all') {
      url.searchParams.set('categoria', filterValue);
    } else {
      url.searchParams.delete('categoria');
      url.searchParams.delete('category');
    }
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }

  function applyFilter(filterValue, options) {
    const nextFilter = filterExists(filterValue) ? filterValue : 'all';
    cards.forEach(function (card) {
      const matches = nextFilter === 'all' || card.dataset.category === nextFilter;
      card.hidden = !matches;
    });

    filterButtons.forEach(function (button) {
      button.classList.toggle('is-active', button.dataset.filter === nextFilter);
    });

    if (options && options.updateUrl) syncUrlFilter(nextFilter);
    updateVisibleCount();
  }

  filterButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      applyFilter(button.dataset.filter || 'all', { updateUrl: true });
    });
  });
  sortCatalogCards();
  cards.forEach(function (card) {
    updateCardGalleryControls(card);
    updateFavoriteButton(card);
  });
  applyFilter(getUrlFilter());

  function setGridCols(cols) {
    if (!grid) return;
    const nextCols = cols === '1' ? '1' : '2';
    grid.classList.remove('cols-1', 'cols-3');
    if (nextCols === '1') grid.classList.add('cols-1');
    gridButtons.forEach(function (button) {
      button.classList.toggle('is-active', button.dataset.gridCols === nextCols);
    });
  }

  gridButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      setGridCols(button.dataset.gridCols || '2');
    });
  });

  function closeAllPanels(except) {
    togglePanels.forEach(function (panel) {
      const key = panel.dataset.togglePanel;
      const isOpen = key === except ? !panel.classList.contains('is-open') : false;
      panel.classList.toggle('is-open', isOpen);

      const button = section.querySelector('[data-toggle-target="' + key + '"]');
      const icon = section.querySelector('[data-toggle-icon="' + key + '"]');
      if (button) button.classList.toggle('is-active', isOpen);
      if (icon) icon.textContent = isOpen ? '−' : '+';
    });
  }

  toggleButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      closeAllPanels(button.dataset.toggleTarget || '');
    });
  });

  section.querySelectorAll('[data-card-gallery-prev], [data-card-gallery-next]').forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (button.classList.contains('is-disabled') || button.getAttribute('aria-disabled') === 'true') return;

      const card = button.closest('[data-product-card]');
      const currentIndex = Number.parseInt(card && card.dataset.galleryIndex ? card.dataset.galleryIndex : '0', 10) || 0;
      const direction = button.hasAttribute('data-card-gallery-next') ? 1 : -1;
      setCardGalleryIndex(card, currentIndex + direction);
    });
  });

  section.querySelectorAll('[data-favorite-toggle]').forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      toggleFavorite(button.closest('[data-product-card]'));
    });
  });

  window.addEventListener('storage', function (event) {
    if (event.key !== favoriteStorageKey) return;
    cards.forEach(updateFavoriteButton);
  });

  section.querySelectorAll('[data-color-swatch]').forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setCardColor(button.closest('[data-product-card]'), button);
    });
  });

  if (modal) {
    const modalImage = modal.querySelector('[data-modal-image]');
    const modalGallery = modal.querySelector('.catalog-modal__gallery');
    const modalCategory = modal.querySelector('[data-modal-category]');
    const modalTitle = modal.querySelector('[data-modal-title]');
    const modalPrice = modal.querySelector('[data-modal-price]');
    const modalDescription = modal.querySelector('[data-modal-description]');
    const modalLink = modal.querySelector('[data-modal-link]');

    function openModal(card) {
      if (!card) return;
      if (modalImage) {
        modalImage.src = card.dataset.image || '';
        modalImage.alt = card.dataset.title || '';
      }
      if (modalGallery) {
        const cardImage = card.querySelector('.catalog-card__image');
        copyModelBgVars(cardImage, modalGallery);
      }
      if (modalCategory) {
        const colorValue = card.dataset.currentColorDisplay || card.dataset.currentColor || '';
        const color = colorValue ? ' / ' + colorValue : '';
        modalCategory.textContent = (card.dataset.categoryLabel || '') + color;
      }
      if (modalTitle) modalTitle.textContent = card.dataset.title || '';
      if (modalPrice) modalPrice.textContent = card.dataset.price || '';
      if (modalDescription) modalDescription.textContent = card.dataset.description || '';
      if (modalLink) modalLink.href = card.dataset.url || '#';

      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    section.querySelectorAll('[data-quick-view]').forEach(function (button) {
      button.addEventListener('click', function () {
        openModal(button.closest('[data-product-card]'));
      });
    });

    if (modalLink) {
      modalLink.addEventListener('click', function (event) {
        if (!modalLink.getAttribute('href') || modalLink.getAttribute('href') === '#') {
          event.preventDefault();
        }
      });
    }

    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.closest('[data-close-modal]')) {
        closeModal();
      }
    });

    window.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
  }
})();

(function () {
  const modal = document.querySelector('[data-discount-modal]');
  if (!modal) return;

  const closeButtons = modal.querySelectorAll('[data-discount-close]');
  const promoBanner = document.querySelector('[data-promo-banner]');
  const promoTriggers = document.querySelectorAll('[data-discount-modal-trigger]');
  const discountCode = modal.dataset.discountCode || 'TRAME20';
  const successPanel = modal.querySelector('[data-discount-success-panel]');
  const codeText = modal.querySelector('[data-discount-code-text]');
  const copyCodeButton = modal.querySelector('[data-discount-code-copy]');
  const signupParam = new URLSearchParams(window.location.search).get('newsletter') || '';
  const hasSignupParam = signupParam.indexOf('descuento') === 0;
  const hasSuccess = Boolean(modal.querySelector('[data-discount-success]')) || hasSignupParam;
  const hasErrors = Boolean(modal.querySelector('[data-discount-errors]'));
  const input = modal.querySelector('.discount-modal__input');
  const storageKey = 'casa-trame-discount-modal-seen-v3';
  const subscribedStorageKey = 'casa-trame-discount-modal-subscribed-v1';
  const sessionStorageKey = 'casa-trame-discount-modal-session-v2';
  // 2026-09-01 00:00 in Lima (UTC-5). Promo is temporarily visible through August 31, 2026.
  const alwaysShowUntil = Date.parse('2026-09-01T05:00:00.000Z');
  const isAlwaysShowWindow = Date.now() < alwaysShowUntil;
  const promoBannerEnd = promoBanner ? Date.parse(promoBanner.dataset.promoEnd || '') : alwaysShowUntil;
  const isPromoBannerWindow = Date.now() < (Number.isFinite(promoBannerEnd) ? promoBannerEnd : alwaysShowUntil);
  let previousOverflow = '';

  function showPromoBanner() {
    if (!promoBanner) return;
    promoBanner.hidden = false;
    document.body.classList.add('has-promo-banner');
  }

  function hidePromoBanner() {
    if (!promoBanner) return;
    promoBanner.hidden = true;
    document.body.classList.remove('has-promo-banner');
  }

  function wasSeen() {
    try {
      return Boolean(window.localStorage.getItem(storageKey));
    } catch (error) {
      return false;
    }
  }

  function hasSubscribed() {
    try {
      return Boolean(window.localStorage.getItem(subscribedStorageKey));
    } catch (error) {
      return false;
    }
  }

  function wasSeenThisSession() {
    try {
      return Boolean(window.sessionStorage.getItem(sessionStorageKey));
    } catch (error) {
      return false;
    }
  }

  function markSeen() {
    try {
      window.localStorage.setItem(storageKey, String(Date.now()));
    } catch (error) {}
    try {
      window.sessionStorage.setItem(sessionStorageKey, 'true');
    } catch (error) {}
  }

  function markSubscribed() {
    try {
      window.localStorage.setItem(subscribedStorageKey, String(Date.now()));
    } catch (error) {}
  }

  function showSuccessState() {
    modal.classList.add('is-discount-success');
    if (codeText) codeText.textContent = discountCode;
    if (successPanel) successPanel.hidden = false;
  }

  function cleanSignupParam() {
    if (!hasSignupParam || !window.history || !window.history.replaceState) return;
    const url = new URL(window.location.href);
    url.searchParams.delete('newsletter');
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }

  function openModal() {
    markSeen();
    previousOverflow = document.body.style.overflow;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    if (input && !hasSuccess && window.matchMedia('(min-width: 769px)').matches) {
      window.setTimeout(function () {
        input.focus({ preventScroll: true });
      }, 80);
    }
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = previousOverflow;
  }

  if (isPromoBannerWindow) {
    showPromoBanner();
  } else {
    hidePromoBanner();
  }

  if (!isPromoBannerWindow) return;

  closeButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      closeModal();
    });
  });

  modal.addEventListener('click', function (event) {
    if (event.target === modal) closeModal();
  });

  window.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) closeModal();
  });

  promoTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      openModal();
    });
  });

  if (copyCodeButton) {
    copyCodeButton.addEventListener('click', function () {
      if (!window.navigator || !window.navigator.clipboard) return;
      window.navigator.clipboard.writeText(discountCode).then(function () {
        copyCodeButton.textContent = 'Copiado';
        window.setTimeout(function () {
          copyCodeButton.textContent = 'Copiar';
        }, 1400);
      }).catch(function () {});
    });
  }

  if (hasSuccess) {
    markSubscribed();
    if (isPromoBannerWindow) {
      showPromoBanner();
    } else {
      hidePromoBanner();
    }
    showSuccessState();
    openModal();
    cleanSignupParam();
    return;
  }

  if (hasErrors) {
    openModal();
    return;
  }

  if (hasSubscribed()) {
    return;
  }

  if (isAlwaysShowWindow && !wasSeenThisSession()) {
    window.setTimeout(function () {
      openModal();
    }, 900);
    return;
  }

  if (!isAlwaysShowWindow) return;
})();

(function () {
  window.CTModelBackgrounds.applyCatalog(document);
})();
